import { mountApp } from './mountApp';
import { registerWebMcpTools } from './agent/webmcp';
import type { SitePage } from './types';
import './styles.css';
import './home-identity.css';
import './reader-design.css';
import './page-imagery.css';

function readInitialPage(): SitePage | null {
  const payload = document.getElementById('__PAGE_DATA__')?.textContent;
  if (!payload) return null;
  try { return JSON.parse(payload) as SitePage; }
  catch { return null; }
}

mountApp(
  document.getElementById('root')!,
  window.location.pathname,
  readInitialPage(),
);

// Optional browser WebMCP registration; unsupported browsers keep the normal reader unchanged.
void registerWebMcpTools().catch(() => undefined);
